<template>
    <b-modal id="modal-codedetail" centered class="modal-codedetail">
      <div class="modal-codedetail-itens">
        <button
          class="modal-codedetail-itens-close"
          @click="$bvModal.hide('modal-codedetail')"
        >
        <img src="@/assets/img/close.png" alt="close" width="30">
        </button>
      </div>
      <div class="modal-codedetail-content">
        <div class="modal-codedetail-content-item row">
          <div class="modal-codedetail-content-item-card"
          :style="{
                backgroundImage: `url('${code.prize_congrats_path}')`,
            }">
          </div> 
          <div class="modal-codedetail-content-item-text">
            <p>{{ code.name }}</p>
            <p>{{ code.store }}</p>
            <p>{{ code.date }}</p>
            <p class="status">{{ code.status }}</p>
          </div>
        </div>   
      </div>
    </b-modal>
  </template>
  
  <script> 
  
  export default {
    props: {
      code: {
        type: Object,
        default: () => {},
      },
    },
  };
  </script>
  
  <style lang="scss" >
  .received{
    background-color: gray !important;
  }
  #modal-codedetail {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      width: 815px;
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 515px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: auto;
      }
    }
  }
  .modal-codedetail {
    width: 100%;
    &-itens {
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -45px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: -15px;
          right: -15px;
          width: 40px;
          height: 40px;
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      gap: 20px;
      width: 100%;
      @media screen and (max-width: 992px) {
        justify-content: center;
      }
      &-item{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        max-height: 270px;
        overflow: hidden;
        gap: 20px;
        @media screen and (max-width: 992px) {
          flex-direction: row;
          height: auto;
          max-height: unset;
        }
        &-card{
          background-color: var(--main-color);
          width: 260px;
          height: 240px;
          background-repeat: no-repeat;
          background-position: top center;
          background-size: cover;
          position: relative;
          border-radius: 20px;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
          margin-right: 20px;
          @media screen and (max-width: 992px){
            margin-right: 0;
          }
          &-text{
              position: absolute;
              top: 180px;
              right: 0;
              left: 0;
              text-align: center;
              p{
                  color: var(--white);
                  margin: 5px 0;
                  line-height: 18px;
              }
              h3{
                  color: var(--white);
                  font-size: 18px;
                  font-family: 'Font Bold';
                  margin: 5px 0;
                  text-transform: uppercase;
              }
          }   
        }
        &-text{
          width: 219px;
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: center;
          @media screen and (max-width: 992px) {
            height: auto;
            width: auto;
          }
          p{
            font-size: 20px;
            line-height: 33px;
          }
          .status{
            background-color: black;
            height: 30px;
            width: 150px;
            color: var(--white);
            padding-left: 10px;
            border-radius: 10px;
            margin-bottom: 0!important;
            text-transform: uppercase;

          }
        }
      }
      
        
    }
  }
</style>